import {
  TableColumnsConfig,
  TableSortConfig,
} from "shared/components/UniversalTable/types";

// ========== COLUMN CONFIGURATION ==========

export const CANDIDATE_COLUMNS_CONFIG: TableColumnsConfig = {
  columns: [
    {
      id: "checkbox",
      label: "",
      minWidth: 40,
      defaultWeight: 0,
      className: "flex justify-center",
    },
    {
      id: "unit",
      label: "Unit",
      minWidth: 100,
      defaultWeight: 2,
      sortKey: "unitId",
    },
    {
      id: "vacancy",
      label: "Verhuur",
      minWidth: 70,
      defaultWeight: 0,
    },
    {
      id: "calendar",
      label: "Kalender",
      minWidth: 85,
      defaultWeight: 0,
    },
    {
      id: "status",
      label: "Status",
      minWidth: 120,
      defaultWeight: 2,
      sortKey: "status",
    },
    {
      id: "action",
      label: "Actie",
      minWidth: 100,
      defaultWeight: 0,
      className: "flex justify-center",
    },
    {
      id: "person",
      label: "Persoon",
      minWidth: 150,
      defaultWeight: 2,
    },
    {
      id: "follow-up",
      label: "Opvolging",
      minWidth: 140,
      defaultWeight: 0,
    },
    {
      id: "candidacy-date",
      label: "Kandidatuur",
      minWidth: 120,
      defaultWeight: 1,
      sortKey: "createDate",
    },
    {
      id: "visit",
      label: "Bezoek",
      minWidth: 120,
      defaultWeight: 1,
      sortKey: "visitDate",
    },
    {
      id: "residents",
      label: "Bew.",
      minWidth: 45,
      defaultWeight: 0,
      className: "flex justify-center",
    },
    {
      id: "docs",
      label: "Docs",
      minWidth: 65,
      defaultWeight: 0,
      className: "flex justify-center",
    },
    {
      id: "agreement",
      label: "Akkoord",
      minWidth: 90,
      defaultWeight: 0,
    },
    {
      id: "mails",
      label: "Mails",
      minWidth: 90,
      defaultWeight: 0,
      className: "flex justify-center",
    },
  ],
  localStorageKey: "candidateTableColumnWidthsV5",
};

// ========== SORT CONFIGURATION ==========

export const CANDIDATE_SORT_CONFIG: TableSortConfig = {
  defaultSortKey: "createDate",
  defaultDirection: "desc",
  fields: [
    {
      key: "unitId",
      extractor: (row) => row.unitId || "",
    },
    {
      key: "status",
      extractor: (row) => {
        const statusOrder: Record<string, number> = {
          interested: 10,
          notify: 9,
          searchingAppointmentMoment: 8,
          "awaiting-alternate-selection": 7,
          "awaiting-interested": 6,
          invited: 5,
          "awaiting-visit": 4,
          approved: 3,
          tenant: 2,
          rejected: 1,
          "not-interested": 0,
        };
        return statusOrder[row.status] ?? -1;
      },
    },
    {
      key: "createDate",
      extractor: (row) => {
        const d = row.createDate instanceof Date ? row.createDate : new Date(row.createDate);
        return d.getTime() || 0;
      },
    },
    {
      key: "visitDate",
      extractor: (row) => {
        if (!row.visitDate) return 0;
        const d = row.visitDate instanceof Date ? row.visitDate : new Date(row.visitDate);
        return d.getTime() || 0;
      },
    },
  ],
  caseSensitive: false,
};

// ========== COMBINED CONFIGURATION ==========

export const CANDIDATE_TABLE_CONFIG = {
  columnsConfig: CANDIDATE_COLUMNS_CONFIG,
  sortConfig: CANDIDATE_SORT_CONFIG,
};
